import { en } from "../localize/en"
import { de } from "../localize/de"

export const TRANSLATIONS = { en, de }
